<template>
  <div>
    -------------
    </div>
</template>

<script>
export default {
  name: 'frame',
  components: {
    // webaboutme
  },
  mounted () {}
}
</script>

  <style>
</style>



// WEBPACK FOOTER //
// src/components/wiki/frame.vue